import { createFileRoute } from '@tanstack/react-router';
import WorkforceInsights from '@/features/workforce-insights';

export const Route = createFileRoute('/_authenticated/workforce-insights/')({
  component: WorkforceInsights,
});
